import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { FileUploadComponent } from '../../../file-upload/file-upload.component';
import { FileUploadService } from 'app/shared/services/file-upload.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { EmployeeService } from 'app/shared/services/employee.service';
import { AuthService } from 'app/shared/services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import * as moment from 'moment';
import { NbThemeService } from '@nebular/theme';



@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.css']
})
export class EmployeeComponent implements OnInit {

  isDark: boolean = false;
  isShowAttachBtn: boolean=false;

  employeeForm: FormGroup;
  isSaveBtnDisabled : boolean= false;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };

  departments =[
    {id: 0, value: 'Administration'},
    {id: 1, value: 'Accounting & Finance'},
    {id: 2, value: 'Human Resourse'},
    {id: 3, value: 'Marketing'},
    {id: 4, value: 'Production'}
   
  ];

  validationMessages = {
    'empId': { 'required': 'Employee Id is required' },
    'empNo': { 'required': 'Employee number is required' },
    'empName': { 'required': 'Employee Name is required' },
    'phone': { 'required': 'Phone Number is required' },
    'email': {'email': 'Email must be a valid email address'},  
  };

  formErrors = {
    'empId': "",
    'empNo': "",
    'empName': "",
    'email': "",
    'phone': "",
  };

  constructor(private fb: FormBuilder,
              private employeeService: EmployeeService,
              private toastr: ToastrService,
              private dialogService: DialogService,
              private router : Router, 
              private themeService: NbThemeService,
              private fileUploadService:FileUploadService,
              private authService: AuthService
             ) { }

  ngOnInit() {

    this.employeeForm = this.fb.group({
      id : [null],
      empId : ['',Validators.required],
      empNo : ['',Validators.required],
      empName : ['',Validators.required],
      nic : [''],
      dateOfBirth : [''],
      gender : [''],  
      permanentAddress : [''],
      postalAddress : [''],
      phone : ['',Validators.required],
      email : ['',Validators.email],    
      department : [''],
      position : [''],
      dateOfJoined : [''], 
      status : [''],
    });


  this.getDataTableRowData();
  this.getControlPermissions();

  this.employeeForm.valueChanges.subscribe((data) => {
    this.logValidationErrors(this.employeeForm);
  });

  this.themeService.onThemeChange()
  .subscribe(themeName =>{
       this.isDark  = themeName.name ==='dark' ? true : false;
     });

  }// end on init

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='EM'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }

  attachFileButtonClick(){
    this.fileUploadService.refNo = this.employeeForm.value.empId;
     const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.width = "75%";
     this.dialogService.openDialog(FileUploadComponent,dialogConfig);
        
    }

  newButtonClick(): void {
    this.isSaveBtnDisabled = false;
    this.isShowAttachBtn=false; 
    this.enableForm();
    this.employeeForm.reset();
    this.resetValiationErrors();
    this.getMaxId();
    
   }


   getMaxId(){
    var empId = 0;
    var sEmpId : String;
  
    this.employeeService.getMaxId()
    .subscribe(
      (res) => {
                  empId = Number(res[0].MaxId) + 1;
                  sEmpId = empId.toString().padStart(6,'0');
                  this.employeeForm.patchValue({
                    empId : "EMP" + sEmpId
                  });
               

                },        
      (err) =>  {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                }, 
      )



   }

  saveButtonClick(): void {
    
    this.logValidationErrors(this.employeeForm,true);
    const formData = this.mapFormValuesToModel();  

          if(this.isFilledFromFields()){
            
              if(!this.employeeForm.value.id){
                this.showProcessingIndicator = true;
                this.employeeService.create(formData)
                .subscribe(
                  (res) => {                             
                              if(res.success === 0){
                                this.employeeForm.patchValue({
                                empId : res.autoId
                                });
                              this.saveButtonClick();
                              this.showProcessingIndicator = false; 
                              
                              }else if(res.success === 1){
                                this.toastr.success('Record created successfully','Success');
                                this.isSaveBtnDisabled = true;     
                                this.isShowAttachBtn = true;                   
                                this.showProcessingIndicator = false; 
                             }   
                            },        
                  (err) =>  {
                              this.toastr.error('Failed to create record','Failure');                            
                              this.showProcessingIndicator = false;
                              if(err instanceof HttpErrorResponse){                 
                                if(err.status == 401){
                                  this.router.navigate(['/login']);
                                }
                              }
                              console.log(err);
                            }, 
                  )
  
                    

            }else{
            this.dialogService.openConfirmDialog('Are you sure you want to update this record?')
            .afterClosed().subscribe(res =>{
              if(res){
              this.showProcessingIndicator = true;
              this.employeeService.update(formData)
            .subscribe(
              (res) => {
                          this.toastr.success('Record updated successfully','Success');
                          this.isSaveBtnDisabled = true;
                          this.showProcessingIndicator = false;  
                        },        
              (err) =>  {
                          this.toastr.error('Failed to update record','Failure');
                          this.showProcessingIndicator = false;
                          if(err instanceof HttpErrorResponse){                 
                            if(err.status == 401){
                              this.router.navigate(['/login']);
                            }
                          }
                          console.log(err);
                        }, 
                      )

          }else{
            this.showProcessingIndicator = false;
          }
            })

        }

      }
      else{
        this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
        this.showProcessingIndicator = false;
        
      } 
                       
         
   }

   enableForm(): void {
    Object.keys(this.employeeForm.controls).forEach(key => {
      this.employeeForm.controls[key].enable();
    });
  }
  
  
  resetValiationErrors(){
    Object.keys(this.employeeForm.controls).forEach(key => {
      this.employeeForm.get(key).setErrors(null) ;
    });
  }

  logValidationErrors(group: FormGroup = this.employeeForm,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      { 
        this.enableForm();
        this.employeeForm.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }


  isFilledFromFields() : boolean {
    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }
        return true;
}

  mapFormValuesToModel(){
    let status;
    if(this.employeeForm.value.status){
      status='Deactivated';    
    }
    else{
      status='Active';
    }  
    let formData ={
      ...this.employeeForm.value,
      dateOfBirth: this.employeeForm.value.dateOfBirth ? moment(this.employeeForm.value.dateOfBirth).format("YYYY-MM-DD"):null,
      dateOfJoined: this.employeeForm.value.dateOfJoined ? moment(this.employeeForm.value.dateOfJoined).format("YYYY-MM-DD"):null,

      status : status,
      createdBy : this.authService.getUserLoggedIn(),
    }

    return formData;
    

  }

 

  


activeStatus = false;
viewEmployee(employee:any){
  if(employee.Status=='Active'){
    this.activeStatus = false;
  }else{
    this.activeStatus = true;
  }
 
  this.employeeForm.patchValue({  
    id            :employee.Id,
    empId         :employee.EmpId,
    empNo         :employee.EmpNo,
    empName      : employee.EmpName,
    nic           : employee.NIC,
    dateOfBirth   : employee.DateOfBirth ? moment(employee.DateOfBirth).format("YYYY-MM-DD"):null,
    gender        : employee.Gender,
    permanentAddress : employee.PermanentAddress,
    postalAddress  : employee.PostalAddress,
    phone          : employee.Phone,
    email          : employee.Email,
    department     : employee.Department,
    position       : employee.Position,
    dateOfJoined   :employee.DateOfJoined ? moment(employee.DateOfJoined).format("YYYY-MM-DD"):null,
    status         : this.activeStatus,    
   
  });

  this.isShowAttachBtn = true;

}

getDataTableRowData(){
  var data = this.employeeService.dataRow;
  if(data){
    this.viewEmployee(data);
  }else{
    this.newButtonClick();
  }


}


}